const contacts = [
  {
    type: 'Direct Contact',
    name: 'Roosevelt Collier',
    email: 'rooseveltthedr@gmail.com'
  }
];

export default contacts;
